import { JobOffer } from "../Models/JobOffer";
import { Ref } from "@tblabs/truffle";
import { ApplyForm } from "../Models/ApplyForm";


export class Router
{
    private history: string[] = [];
    
    constructor(private hash: Ref<string>)
    { }
    
    private GoTo(path: string): void
    {
        this.hash.value = path;
    }
    
    public GoToLoginPage(): void
    {
        this.GoTo(`login`);
    }
    
    public GoToApplyView(x: ApplyForm): void
    {
        this.GoTo(`admin/apply/${x.Id}/view`);
    }

    public GoToOfferEdit(offer: JobOffer): void
    {
        this.GoTo(`admin/offer/${offer.Id}/edit`);
    }

    public GoToOfferView(offer: JobOffer): void
    {
        this.GoTo(`job/${offer.Id}`);
    }
 
    public GoToJobsListPage(): void
    {
        this.GoTo(`jobs`);
    }

    public GoToMainPage(): void
    {
        this.GoTo(`admin/main`);
    }
    
    public GoToApplyFormPage(offer: JobOffer): void
    {
        this.GoTo(`job/${offer.Id}/apply`);
    }

    public GoBack()
    {
        /*
        TO NIE DZIAŁA:

        history.back(); // cofa adres ale nie przeładowuje strony
        location.reload(); // to też nie przeładowuje
        */
        this.history.pop();
        this.hash.value = this.history.pop() || "jobs";
    }
}

